<!-- @format -->

<template>
	<pc-config-provider>
		<div v-if="operation" class="head-title">
			<span>{{ title }}</span>
			<el-button type="primary" link icon="Plus" @click="handleGroupingAdd()">添加</el-button>
		</div>
		<div class="head-container">
			<el-input v-model="searchName" :placeholder="`请输入${title}`" clearable style="margin-bottom: 20px" />
		</div>
		<div class="head-container">
			<el-tree
				ref="treeRef"
				class="tree-common"
				:node-key="exhibition.id"
				:data="datas"
				:props="{ label: exhibition.label, children: exhibition.children }"
				:expand-on-click-node="false"
				:filter-node-method="filterNode"
				highlight-current
				:default-expand-all="false"
				:current-node-key="checkedValue"
				:show-checkbox="checkbox"
				:default-checked-keys="checkedkeys"
				:default-expanded-keys="[currentKey]"
				@node-click="handleNodeClick"
				@check="nodeCheck"
			>
				<template #default="{ node, data }">
					<span :class="checkbox ? 'isclicked custom-tree-node' : 'custom-tree-node'">
						<span class="treeName" :title="node.label">
							<!-- <el-icon><Folder /></el-icon> -->
							<el-icon v-if="data[exhibition.icon]"><component :is="data[exhibition.icon]" /></el-icon>
							{{ node.label }}
						</span>
						<span class="treeIcon">
							<span v-if="data[exhibition.id] === checkedValue && operation">
								<el-tooltip content="修改" placement="top">
									<el-button type="primary" link icon="Edit" @click="editiconGroups(data)"></el-button>
								</el-tooltip>
								<el-tooltip content="删除" placement="top">
									<el-button type="danger" link icon="Delete" @click="deleteGroups(data)"></el-button>
								</el-tooltip>
								<el-tooltip content="添加子项目" placement="top">
									<el-button type="danger" link icon="Plus" @click="plusiconGroups(data[exhibition.id])"></el-button>
								</el-tooltip>
							</span>
							<span
								v-if="
									data[exhibition.id] === checkedValue &&
									data[`${exhibition.editkey}`] == exhibition.editid &&
									isclickshow
								"
							>
								<el-tooltip content="修改" placement="top">
									<el-button type="primary" link icon="Edit" @click="exhibitionClicks('修改', data)"></el-button>
								</el-tooltip>
								<el-tooltip content="删除" placement="top">
									<el-button type="danger" link icon="Delete" @click="exhibitionClicks('删除', data)"></el-button>
								</el-tooltip>
							</span>
						</span>
					</span>
				</template>
			</el-tree>
		</div>
		<!-- 添加或修改分组配置对话框 -->
		<el-dialog
			v-model="openGrouping"
			:close-on-click-modal="false"
			custom-class="smallDialog-common"
			:title="titleGrouping"
			width="45%"
			append-to-body
		>
			<el-form ref="addgroupingRef" :model="formGrouping" :rules="rulesGrouping" label-width="120px">
				<el-row>
					<el-col v-for="item in form" :key="item.code" :span="16" :offset="4">
						<el-form-item v-if="item.type == 'input'" :label="item.name" :prop="item.code">
							<el-input v-model="formGrouping[item.code]" :placeholder="`请输入${item.name}`" />
						</el-form-item>
						<el-form-item v-if="item.type == 'select'" :label="item.name" :prop="item.code">
							<!-- <el-input v-model="formGrouping[item.code]" :placeholder="`请输入${item.name}`" /> -->
							<el-select
								v-model="formGrouping[item.code]"
								:placeholder="`请选择${item.name}`"
								clearable
								style="width: 100%"
							>
								<el-option
									v-for="dict in item.data && item.data.length ? item.data : []"
									:key="dict.value"
									:label="dict.label"
									:value="dict.value"
								/>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="cancel">取 消</el-button>
					<el-button type="primary" @click="submitForm">确 定</el-button>
				</div>
			</template>
		</el-dialog>
	</pc-config-provider>
</template>

<script setup lang="ts">
	import { PcConfigProvider } from '@/components';
	const { proxy } = getCurrentInstance();
	const openGrouping = ref<boolean>(false);
	const formGrouping = ref<any>({});
	const searchName = ref<string>('');
	const titleGrouping = ref<string>('');
	const addParentId = ref<any>(null);
	const props = defineProps({
		currentKey: {
			type: String || Number,
			default: '',
		},
		title: {
			type: String,
			default: '',
		},
		checkbox: {
			type: Boolean,
			default: false,
		},
		isclickshow: {
			type: Boolean,
			default: false,
		},
		operation: {
			type: Boolean,
			default: false,
		},
		checkedkeys: {
			type: Array as any,
			default() {
				return [];
			},
		},
		datas: {
			type: Array,
			default() {
				return [];
			},
		},
		form: {
			type: Array as any,
			default() {
				return [];
			},
		},
		exhibition: {
			type: Object,
			default() {
				return {
					icon: 'icon',
					label: 'label',
					children: 'children',
					id: 'id',
					editkey: '',
					editid: '',
				};
			},
		},
	});
	const checkedValue = ref<any>(props.currentKey);
	const rulesGrouping = ref({});

	const emit = defineEmits(['nodeClick', 'submit', 'deleteData', 'nodeCheck', 'exhibitionClick']);

	/** 节点单击事件 */
	function handleNodeClick(data) {
		checkedValue.value = data[props.exhibition.id];
		emit('nodeClick', data);
	}

	/** 节点复选框变化 */
	function nodeCheck(node) {
		const checkedNodes = proxy.$refs['treeRef'].getCheckedNodes();
		const checkedKeys = proxy.$refs['treeRef'].getCheckedKeys();
		const data = {
			checkedNodes,
			checkedKeys,
			node,
		};
		emit('nodeCheck', data);
	}

	/** 通过条件过滤节点  */
	const filterNode = (value, data) => {
		if (!value) return true;
		return data[props.exhibition.label].indexOf(value) !== -1;
	};
	/** 根据名称筛选部门树 */
	watch(searchName, (val) => {
		proxy.$refs['treeRef'].filter(val);
	});
	/** 新增按钮操作 */
	function handleGroupingAdd() {
		reset();
		addParentId.value = null;
		openGrouping.value = true;
		titleGrouping.value = `新增${props.title}`;
	}
	/** 取消分组按钮 */
	function cancel() {
		openGrouping.value = false;
		reset('cancel');
	}
	/** 提交分组按钮 */
	function submitForm() {
		proxy.$refs['addgroupingRef'].validate((valid) => {
			if (valid) {
				emit('submit', formGrouping.value, addParentId.value);
				openGrouping.value = false;
			}
		});
	}
	//权限控制的按钮
	function exhibitionClicks(type, data) {
		emit('exhibitionClick', type, data);
	}
	/** 添加子项目按钮 */
	function plusiconGroups(id) {
		reset();
		addParentId.value = id;
		openGrouping.value = true;
		titleGrouping.value = `新增${props.title}`;
	}
	/** 修改 */
	function editiconGroups(data) {
		reset();
		addParentId.value = null;
		openGrouping.value = true;
		titleGrouping.value = `修改${props.title}`;
		if (props.form) {
			props.form.map((item) => {
				formGrouping.value[item.code] = data[item.code];
			});
			formGrouping.value[props.exhibition.id] = data[props.exhibition.id];
		}
	}
	/** 删除 */
	function deleteGroups(data) {
		ElMessageBox.confirm(`是否确认删除名称为"${data[props.exhibition.label]}"的数据项？`, '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		})
			.then(() => {
				emit('deleteData', data);
			})
			.catch(() => {});
	}

	/** 分组表单重置 */
	function reset(data) {
		if (props.form) {
			props.form.map((item) => {
				formGrouping.value[item.code] = undefined;
			});
			formGrouping.value[props.exhibition.id] = undefined;
		}
		if (data) {
			proxy.$refs['addgroupingRef'].clearValidate();
		}
	}

	// 第一次渲染
	function getOne() {
		// 	const rulesGrouping = ref<any>({
		// 	groupName: [{ required: true, message: '分组名称不能为空', trigger: 'blur' }],
		// 	groupCode: [{ required: true, message: '分组编码不能为空', trigger: 'blur' }],
		// });
		if (props.form) {
			props.form.map((item) => {
				rulesGrouping.value[item.code] = [
					{ required: item.required, message: `${item.name}不能为空`, trigger: 'blur' },
				];
				formGrouping.value[item.code] = undefined;
			});
			formGrouping.value[props.exhibition.id] = undefined;
		}
	}
	getOne();
</script>

<style lang="scss" scoped>
	:deep(.customName) {
		background: #e7f0fa !important;
	}

	.head-title {
		min-height: 45px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: var(--el-text-color-regular);
	}

	.head-container {
		:deep(.el-tree) {
			.el-tree-node__content {
				height: 35px;
				line-height: 35px;
			}

			.el-tree-node__children {
				overflow: visible;
			}
		}
	}

	.custom-tree-node {
		// flex: 1;
		// display: flex;
		// align-items: center;
		// justify-content: space-between;
		width: calc(100% - 30px);
		font-size: 14px;
		padding-right: 8px;
		vertical-align: middle;

		.treeName {
			display: inline-block;
			width: calc(100% - 40px);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			vertical-align: middle;
		}

		.treeIcon {
			display: inline-block;
			width: 40px;
			// margin-right: 15px;
			vertical-align: middle;

			span {
				.el-button {
					margin-left: 0px;
				}
			}
		}
	}

	.isclicked {
		width: calc(100% - 50px);
	}
</style>
